import { getProfileV2 } from '@/actions/fetchProfile';
import { D365_USER_ID } from '@/constants/profileManagement';
import { useProductContext } from '@/context/productContext';
import SessionStorage from '@/utils/sessionStorage';
import { useEffect } from 'react';
import useTriggerRequest from './useTriggerRequest';
import { useProfileContext } from '@/context/profileContext';
import Cookies from '@/utils/cookie';

const useDeviceChange = () => {
  const { dispatch } = useProfileContext();
  const { state: product } = useProductContext();
  const { selectedProduct } = product || {};
  const { accountId } = selectedProduct || {};

  //   // Fetch Profile
  const fetch = (...args: any) => getProfileV2.apply(null, args);
  const { promisifyTrigger } = useTriggerRequest({ fetch });

  useEffect(() => {
    if (accountId) {
      Cookies.set(D365_USER_ID, accountId);
      const trigger = async () => {
        const profile = await promisifyTrigger();
        dispatch.loadProfile({ ...profile, isLoggedIn: true });
      };
      trigger();
    }
  }, [accountId]);
};

export default useDeviceChange;
